import api from "api";
import { queryKeys } from "utils/misc";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";

const useTherapist = (overrideId?: number) => {
  const defaultId = useId();
  const id = overrideId ?? defaultId;
  const key = queryKeys.therapist(id);
  return useQuery(key, () => api.parse("GET /therapists/{id}", [id]));
};

export default useTherapist;
